<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    let {
        label = "",
        value = $bindable(),
        placeholder = "Select an option...",
        name = "",
        class: cls = "",
        inputClass = "",
        disabled = false,
        autocomplete = undefined,
    } = $props();

    const labelCls = $derived(twMerge(
        "tw:block tw:text-sm tw:font-medium tw:text-gray-900 tw:relative tw:w-full",
        cls,
    ));
    const inputCls = $derived(twMerge(
        "tw:bg-gray-50 tw:border tw:border-gray-300 tw:text-gray-900 tw:text-sm tw:rounded-lg tw:focus:ring-blue-500 tw:focus:border-blue-500 tw:block tw:w-full tw:px-2.5 tw:py-2",
        inputClass,
    ));
</script>

<label class={labelCls}>
    <span>{label}</span>
    <input
        type="email"
        {name}
        bind:value={value}
        class={inputCls}
        {placeholder}
        {disabled}
        {autocomplete}
        data-input-name={name}
    />
</label>
